import React, { useState } from "react";
import styles from "../../_css/TrainModuleNewSession.module.css";
import TrainAIPopup from "./TrainAIPopup";
import ChatPopup from "../UI/ChatPopup";
import VoiceChatPopup from "../Modals/VoiceChatPopup";

const NewSession = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [showChat, setShowChat] = useState(false);

  const handleOpenChat = (mode) => {
    setShowChat(mode);
    setShowPopup(false);
  };


  return (
    <>
      <div className={styles.trainSessionContainer}>
        <div className={styles.trainSessionTitle}>Train AI to Reflect Your Voice</div>
        <button
          className={styles.trainSessionButton}
          onClick={() => setShowPopup(true)}
        >
          Train New AI Session
        </button>
      </div>
      <TrainAIPopup
        show={showPopup}
        onHide={() => setShowPopup(false)}
        onOpenChat={handleOpenChat}
      />
      <ChatPopup show={showChat === "text"} onClose={() => setShowChat(false)} isNewSession={true} />
      <VoiceChatPopup show={showChat === "voice"} onClose={() => setShowChat(false)} isNewSession={true} />
    </>
  );
};

export default NewSession; 